import { Characteristics } from "../models/MarketplaceModel";

export const getCharacteristic = (characteristics: Array<Characteristics>, key: string) => {
    const value = characteristics.filter((el: Characteristics) => el.id === key)
    if(!value || !value.length) return null
    return value[0].value || null
}